import { render, staticRenderFns } from "./Win.vue?vue&type=template&id=820fb642&scoped=true&lang=html"
import script from "./Win.vue?vue&type=script&lang=js"
export * from "./Win.vue?vue&type=script&lang=js"
import style0 from "./Win.vue?vue&type=style&index=0&id=820fb642&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820fb642",
  null
  
)

export default component.exports